import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useEffect } from 'react';
import type { TeamComment } from '@/api/v4/team-comments.api';
import { fetchTeamComments } from '@/api/v4/team-comments.api';
import { QueryKey } from '@/config/query-client';

import { teamIdState } from '../../../team.state';
import { useAtomValue } from 'jotai';

export const useTeamComments = () => {
  const queryClient = useQueryClient();
  const teamId = useAtomValue(teamIdState);

  const fetchTeamMeetings = async (): Promise<TeamComment[]> => {
    if (!teamId) return [];
    return fetchTeamComments(teamId);
  };

  const query = useQuery({
    queryKey: [QueryKey.TeamComments, teamId],
    queryFn: fetchTeamMeetings,
    enabled: !!teamId,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.data) {
      void queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamActionsInfo, teamId],
      });
    }
  }, [query.data, queryClient, teamId]);

  return query;
};
